import { Button } from '@mui/material'
import React, { useState, useRef, useEffect, useContext } from 'react'
// import CustomInput from '../../atoms/Inputs/CustomInput'
// import PrimaryButton from '../../atoms/PrimaryButton'
import { currencyFormat } from '../../custom/common/components'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { isValidHttpUrl } from '@/product/common/components'
const CartItem = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allLocations } = customCommonContext
    const [product, setProduct] = useState()
    const [userLocation, setUserLocation] = useState('')

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    return (
        <>
            {product ? (
                <>
                    <div className="cartItem d-flex justify-content-between align-items-start">
                        <div className="itemInfo">
                            <div className="pclImg">
                                <img
                                    src={
                                        isValidHttpUrl(product.projects_avatar)
                                            ? product.projects_avatar
                                            : global.site_url +
                                              '/uploads/product/' +
                                              product.projects_avatar
                                    }
                                    alt={product.projects_title}
                                    onError={(e) =>
                                        (e.target.src =
                                            '/assets/images/noimage.png')
                                    }
                                />
                            </div>
                            <div className="listContent">
                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                    <h2 className="listProdTitle">
                                        {product.projects_title}
                                    </h2>
                                    {props.from === 'invoice' ? (
                                        <div className="badge badge-danger ml-3 px-2 py-1">
                                            {product.returned === 1
                                                ? 'Returned'
                                                : null}
                                        </div>
                                    ) : null}
                                </div>
                                <div>
                                    <span className="pick-loc-h">
                                        {'Pick Up Location : '}
                                    </span>{' '}
                                    <span className="pick-loc">
                                        {allLocations?.length
                                            ? allLocations.filter(
                                                  (item) =>
                                                      item?.id ===
                                                      parseInt(
                                                          product?.custom_projects_location
                                                      )
                                              )[0]?.full_address || ''
                                            : ''}
                                    </span>
                                </div>
                                {/* <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-1">
                                        Location:{' '}
                                        <b>
                                            {' '}
                                            {product?.custom_projects_location &&
                                            allLocations?.length
                                                ? allLocations.filter(
                                                      (data) =>
                                                          data.active == 1 &&
                                                          data.id ==
                                                              product?.custom_projects_location
                                                  )[0]?.name
                                                : '-'}
                                        </b>
                                    </h5>
                                </div> */}
                                {/* <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-1">
                                        Pick Up Instruction:{' '}
                                        <b>
                                            {' '}
                                            {product?.custom_projects_location &&
                                            allLocations?.length
                                                ? allLocations.filter(
                                                      (data) =>
                                                          data.active == 1 &&
                                                          data.id ==
                                                              product?.custom_projects_location
                                                  )[0]?.Pick_Up_Instractions
                                                : '-'}
                                        </b>
                                    </h5>
                                </div> */}

                                {/* <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-1">
                                        Location in facility :{' '}
                                        <b>
                                            {' '}
                                            {product.custom_projects_bin_location
                                                ? product.custom_projects_bin_location
                                                : '-'}
                                        </b>
                                    </h5>
                                </div> */}

                                {props.from == 'buynowcart' ||
                                props.from == 'buynowcheckout' ||
                                (props.from == 'invoice' &&
                                    product.buynow_autype === 'buynow') ? (
                                    <>
                                        {/* <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Amount:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.amount
                                                    )}
                                                </span>
                                            </h5>
                                           
                                        </div> */}
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Sub-total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.per_total
                                                    )}
                                                </span>
                                            </h5>
                                            <h5>
                                                <span>Quantity:</span>{' '}
                                                <span>{product.qty}</span>
                                            </h5>
                                            {/* {product.projects_auction &&
                                            product.paid === 0 &&
                                            product.partial === 0 &&
                                            product.active !== 2 ? (
                                                <Button
                                                    className="textTransformInitial noPrint"
                                                    onClick={() =>
                                                        props.handleChangeAmount(
                                                            product,
                                                            'changeAmount'
                                                        )
                                                    }
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    <span className="material-icons w-auto">
                                                        edit
                                                    </span>
                                                    {'Change Amount'}
                                                </Button>
                                            ) : null} */}
                                        </div>

                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    ZB Fee(
                                                    {
                                                        product.buyer_premium_percent
                                                    }
                                                    %):
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_premium
                                                    )}
                                                </span>
                                            </h5>
                                            <h5>
                                                <span>Item ID:</span>
                                                <span>
                                                    {product?.item_id ||
                                                        product?.projects_item_id ||
                                                        product.project_id ||
                                                        '-'}
                                                </span>
                                            </h5>
                                        </div>

                                        {product.coupon_discount ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Promo Discount'}:
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.coupon_discount,
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}

                                        {product.coupon_discount ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Total After Discount'}
                                                        :
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            _.sum([
                                                                parseFloat(
                                                                    product?.per_total_after_discount ||
                                                                        0
                                                                ),
                                                                parseFloat(
                                                                    product?.total_premium ||
                                                                        0
                                                                ),
                                                            ]) || '0.00',
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}

                                        {product?.total_tax ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        Tax(
                                                        {product.tax_percent}%):
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_tax
                                                        )}
                                                    </span>
                                                </h5>
                                                <h5>
                                                    <span>Bin Location:</span>
                                                    <span>
                                                        {product?.custom_projects_bin_location ||
                                                            '-'}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}

                                        {product.credit_discount ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Wallet Paid'}:
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.credit_discount,
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}

                                        {product.card_discount ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Card Paid'}:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.card_discount,
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}

                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>{'Total Paid'}:</span>
                                                <span>
                                                    {currencyFormat(
                                                        _.sum([
                                                            parseFloat(
                                                                product?.card_discount ||
                                                                    0
                                                            ),
                                                            parseFloat(
                                                                product?.credit_discount ||
                                                                    0
                                                            ),
                                                        ]) || '0.00',
                                                        2
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </>
                                ) : props.from == 'cart' ||
                                  props.from == 'checkout' ||
                                  (props.from == 'invoice' &&
                                      product.buynow_autype === 'auction') ||
                                  product.buynow_autype === 'live' ? (
                                    product.restocking_fee ? (
                                        <>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Restocking Fee:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.restocking_fee
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                            {/* <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Total:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            _.sum([
                                                                parseFloat(product?.card_discount || 0),
                                                                parseFloat(product?.credit_discount || 0),
                                                            ])
                                                        )}
                                                    </span>
                                                </h5>
                                            </div> */}
                                        </>
                                    ) : (
                                        <>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Sub-total:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.per_total
                                                        )}
                                                    </span>
                                                </h5>
                                                <h5>
                                                    <span>{'Quantity'}:</span>{' '}
                                                    <span>{product.qty}</span>
                                                </h5>
                                                {/* {product.projects_auction &&
                                                product.paid === 0 &&
                                                product.partial === 0 &&
                                                product.active !== 2 ? (
                                                    <Button
                                                        className="textTransformInitial noPrint"
                                                        onClick={() =>
                                                            props.handleChangeAmount(
                                                                product,
                                                                'changeAmount'
                                                            )
                                                        }
                                                        style={{
                                                            whiteSpace:
                                                                'nowrap',
                                                        }}
                                                    >
                                                        <span className="material-icons w-auto">
                                                            edit
                                                        </span>
                                                        {'Change Amount'}
                                                    </Button>
                                                ) : null} */}
                                            </div>

                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'ZB Fee'} (
                                                        {
                                                            product.buyer_premium_percent
                                                        }
                                                        %):
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_premium,
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                                <h5>
                                                    <span>Item ID:</span>
                                                    <span>
                                                        {product?.item_id ||
                                                            product?.projects_item_id ||
                                                            product.project_id ||
                                                            '-'}
                                                    </span>
                                                </h5>
                                                {/* {props.from == 'invoice' ? (
                                                    <h5>
                                                        <span>Status:</span>
                                                        <span>
                                                            {product.delivered ===
                                                            1
                                                                ? 'Picked Up'
                                                                : product.delivered ===
                                                                  2
                                                                ? 'Abandoned'
                                                                : product?.returned ===
                                                                  1
                                                                ? 'Returned'
                                                                : 'Not Picked Up'}
                                                        </span>
                                                    </h5>
                                                ) : null} */}
                                            </div>

                                            {product.coupon_discount ? (
                                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                    <h5>
                                                        <span>
                                                            {'Promo Discount'}:
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                product.coupon_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </h5>
                                                </div>
                                            ) : null}

                                            {product.coupon_discount ? (
                                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                    <h5>
                                                        <span>
                                                            {
                                                                'Total After Discount'
                                                            }
                                                            :
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                _.sum([
                                                                    parseFloat(
                                                                        product?.per_total_after_discount ||
                                                                            0
                                                                    ),
                                                                    parseFloat(
                                                                        product?.total_premium ||
                                                                            0
                                                                    ),
                                                                ]) || '0.00',
                                                                2
                                                            )}
                                                        </span>
                                                    </h5>
                                                </div>
                                            ) : null}

                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Tax'} (
                                                        {product.tax_percent}%):
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_tax,
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                                {/* <h5>
                                                    <span>Bin Location:</span>
                                                    <span>
                                                        {product.project_id
                                                            ? product?.custom_projects_bin_location
                                                            : '-'}
                                                    </span>
                                                </h5> */}
                                            </div>

                                            {product.credit_discount ? (
                                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                    <h5>
                                                        <span>
                                                            {'Wallet Paid'}:
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                product.credit_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </h5>
                                                </div>
                                            ) : null}

                                            {product.card_discount ? (
                                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                    <h5>
                                                        <span>
                                                            {'Card Paid'}:
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                product.card_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </h5>
                                                </div>
                                            ) : null}

                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Total Paid'}:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            _.sum([
                                                                parseFloat(
                                                                    product?.card_discount ||
                                                                        0
                                                                ),
                                                                parseFloat(
                                                                    product?.credit_discount ||
                                                                        0
                                                                ),
                                                            ]) || '0.00',
                                                            2
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        </>
                                    )
                                ) : null}
                            </div>
                        </div>
                        <div className="cart-price">
                            {currencyFormat(
                                product.restocking_fee
                                    ? product.restocking_fee
                                    : _.sum([
                                          parseFloat(
                                              product?.card_discount || 0
                                          ),
                                          parseFloat(
                                              product?.credit_discount || 0
                                          ),
                                      ]),
                                2
                            )}
                        </div>
                        <div className="listActBtn"></div>
                    </div>
                </>
            ) : null}
        </>
    )
}
export default CartItem
